import React, { createContext, useContext, useState } from "react";

// Création du contexte
const AreaContext = createContext();

// Hook personnalisé pour l'utiliser facilement
export const useAreaContext = () => useContext(AreaContext);

// Fournisseur du contexte
export const AreaProvider = ({ children }) => {
  const [allAreas, setAllAreas] = useState([]);
  const [selectedSites, setSelectedSites] = useState([]);

  const addFilter = (filter) => {
    setSelectedSites((prev) => [...prev, filter]);
  };

  const clearFilters = () => setSelectedSites([]);

  return (
    <AreaContext.Provider
      value={{
        allAreas,
        setAllAreas,
        selectedSites,
        addFilter,
        clearFilters,
      }}
    >
      {children}
    </AreaContext.Provider>
  );
};
